module.exports = __webpack_public_path__ + "img/01-1智能仓储.f32e98ed.png";